import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetIndexViewSummaryBlockRequest extends BaseServiceRequest {
    constructor(msid,osid,symbol) {
        super();
        super.addPathParameter(msid.toString());
        super.addRequestParameter("isym", symbol);
        super.addRequestParameter("iosid", osid);
        super.addRequestUri("indexsumblock.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "IndexSummaryBlockResponse";
    }
}

export default GetIndexViewSummaryBlockRequest;
